import React, { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import Loader from "../../../Base/Components/Loader/Loader";
import QRCode from "qrcode";
import pdfMake from "pdfmake/build/pdfmake";
import { Image } from "pdfmake/build/pdfmake";
import { logoPPFBase64 } from "../Evaluacion/Imgs";

const ModalQRMarcaje = ({showEtiqueta,setShowEtiqueta,selected,setSelected, getInfo}) => {
  const toast = useRef(null);
  const [loading, setLoading] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [logo, setLogo] = useState(logoPPFBase64.avatar);

  const generarQR = async () => {
    setLoading(true);
    const contenido = [];

    // Generar los QR de forma asíncrona
    const qrCodes = await Promise.all(
      selected.map(
        (item) =>
          new Promise((resolve) => {
            const info = { IdQR: item?.IdQR, idSeccion: '1' };
            QRCode.toDataURL(
              JSON.stringify(info),
              { errorCorrectionLevel: "Q" },
              (err, url) => {
                resolve({ ...item, CodigoQR: url });
              }
            );
          })
      )
    );

    // let qrCodes = await Promise.all(
    //   selected.map(
    //     (item) =>
    //       new Promise((resolve) => {
    //         const info = { IdQR: item?.IdQR, idSeccion: 'ALLZOLIPPF'  };
    //         QRCode.toDataURL(
    //           JSON.stringify(info),
    //           { errorCorrectionLevel: "Q" },
    //           (err, url) => {
    //             resolve({ ...item, CodigoQR: url });
    //           }
    //         );
    //       })
    //   )
    // );
    // Organizar los QR en filas de 2 columnas y 2 filas por página
    let filas = [];
    qrCodes.forEach((item, index) => {
      const qrCell = {
        margin: [10, 10, 10, 10],
        table: {
          widths: ["100%"],
          body: [
            [
              {
                image: item.CodigoQR,
                width: 300,
                height: 300,
                alignment: "center",
                margin: [-35, -25, 0, -25],
              },
            ],
            [
              { 
                  text: `${item?.Descripcion}`,
                  style: "infoGeneral2", 
                  border:[false, false,false, false]
              }
            ],
            [
              {
                image: logo,
                width: 80,
                margin: [85, -180, 10, 10],
                border:[false, false,false, false]
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function () {
              return 1;
          },
          vLineWidth: function () {
              return 1;
          },
          hLineColor: function () {
              return 'black';
          },
          vLineColor: function () {
              return 'black';
          },
          hLineStyle: function () {
              return { dash: { length: 3, space: 2 } };
          },
          vLineStyle: function () {
              return { dash: { length: 3, space: 2 } };
          }
        }
      };

      // Agregar el QR a la fila actual
      if (index % 2 === 0) {
        filas.push([qrCell]); // Nueva fila con la primera columna
      } else {
        filas[filas.length - 1].push(qrCell); // Segunda columna de la fila
      }

      // Si el número de elementos es impar, agregar celda vacía para completar la fila
      if (index === qrCodes.length - 1 && qrCodes.length % 2 !== 0) {
        filas[filas.length - 1].push({ text: "", margin: [10, 10, 10, 10] });
      }

      // Agregar una página cada 2 filas (4 QR)
      if ((index + 1) % 4 === 0 || index === qrCodes.length - 1) {
        contenido.push({
          table: { widths: ["50%", "50%"], body: filas },
          layout: { defaultBorder: false },
        });
        filas = []; // Reiniciar para la siguiente página
        if (index + 1 < qrCodes.length)
          contenido.push({ text: "", pageBreak: "after" });
      }
    });

    // Definición del PDF
    const docDefinition = {
      pageSize: "LETTER",
      pageMargins: [10, 20, 10, 20],
      content: contenido,
      styles: {
        infoGeneral2: { fontSize: 8, alignment: "center", marginTop:5 },
      },
    };

    // Crear PDF
    const doc = pdfMake.createPdf(docDefinition);
    doc.getDataUrl((url) => {
      setPdfUrl(url);
    });

    setLoading(false);
  };

  const onHideReporte = () => {
    setShowEtiqueta(false);
    setSelected([]);
    getInfo()
  };

  useEffect(() => {
    generarQR();
  }, []);

  return (
    <Dialog
      visible={showEtiqueta}
      onHide={onHideReporte}
      style={{ width: "55%", height: "80%" }}
    >
      {/* <h4 className="mx-2">Código QR</h4> */}
      <Loader loading={loading} querySelector={"#Modal"} />
      <Toast ref={toast} />
      <div id="Modal">
        {!loading && pdfUrl && (
          <iframe
            src={pdfUrl}
            style={{ width: "100%", height: "70vh", border: "1px solid #ccc" }}
            id="foo"
            title="Reporte QR PDF"
          />
        )}
      </div>
    </Dialog>
  );
};

export default ModalQRMarcaje;
